module.exports = __webpack_public_path__ + "img/logo.a28cdc2c.svg";